"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Wrapper;

var _react = _interopRequireWildcard(require("react"));

var _reactThreeFiber = require("react-three-fiber");

var THREE = _interopRequireWildcard(require("three"));

var _OBJLoader = require("three/examples/jsm/loaders/OBJLoader");

var _DDSLoader = require("three/examples/jsm/loaders/DDSLoader");

var _MTLLoader = require("three/examples/jsm/loaders/MTLLoader");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ObjectFile(_ref) {
  var _ref$objFile = _ref.objFile,
      objFile = _ref$objFile === void 0 ? "R_A_A0_GREATSWORD02.obj" : _ref$objFile,
      _ref$mtlFile = _ref.mtlFile,
      mtlFile = _ref$mtlFile === void 0 ? "R_A_A0_GREATSWORD02.mtl" : _ref$mtlFile,
      _ref$isRotating = _ref.isRotating,
      isRotating = _ref$isRotating === void 0 ? true : _ref$isRotating;
  var mesh = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      obj = _useState2[0],
      setObj = _useState2[1]; // Manager


  var loadingManagerMtl = (0, _react.useMemo)(function () {
    return new THREE.LoadingManager();
  }, []);
  loadingManagerMtl.addHandler(/\.dds$/i, new _DDSLoader.DDSLoader()); // MTL Loader

  var mtlLoader = (0, _react.useMemo)(function () {
    return new _MTLLoader.MTLLoader(loadingManagerMtl);
  }, [loadingManagerMtl]);
  mtlLoader.setPath("https://cdn.fhxrestoration.com/common/entities/items/objects/"); // TODO
  // Object Loader

  var objectLoader = (0, _react.useMemo)(function () {
    return new _OBJLoader.OBJLoader();
  }, []);
  objectLoader.setPath("https://cdn.fhxrestoration.com/common/entities/items/objects/"); // TODO

  var onProgress = (0, _react.useCallback)(function (event) {
    if (event.lengthComputable) {
      var percentComplete = event.loaded / event.total * 100;
      console.log("".concat(Math.round(percentComplete), "% downloaded"));
    }
  }, []);
  var onError = (0, _react.useCallback)(function (event) {
    console.error("ERROR:", event);
  }, []);
  var setObjInMesh = (0, _react.useCallback)(function (object) {
    console.log("OBJECT", object);
    var tmp = object;
    tmp.scale.x = 1.5;
    tmp.scale.y = 1.5;
    tmp.position.y = -0.5;
    tmp.position.z = 3.5;
    tmp.rotateX(-1.5);
    tmp.rotateY(0);
    tmp.rotateZ(1.5);
    setObj(tmp);
  }, []);
  var loadObject = (0, _react.useCallback)(function (materials) {
    console.log("MATERIALS", materials);
    objectLoader.setMaterials(materials) // .addMaterials(MtlObjBridge.addMaterialsFromMtlLoader(loadedMats), true)
    .load(objFile, function (objjj) {
      setObjInMesh(objjj);
    });
  }, [objFile, objectLoader, setObjInMesh]);
  var onLoadMaterial = (0, _react.useCallback)(function (materials) {
    materials.preload();
    loadObject(materials);
  }, [loadObject]);
  (0, _react.useEffect)(function () {
    console.log("EFFECT");
    mtlLoader.load(mtlFile, onLoadMaterial, onProgress, onError);
  }, [mtlFile, mtlLoader, onError, onLoadMaterial, onProgress]);
  (0, _reactThreeFiber.useFrame)(function () {
    if (mesh.current && isRotating) {
      mesh.current.rotation.x += 0.0;
      mesh.current.rotation.y += 0.0;
      mesh.current.rotation.z += 0.055;
    }
  });
  return obj ? /*#__PURE__*/_react.default.createElement("primitive", {
    ref: mesh,
    object: obj
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
}

function Wrapper() {
  return /*#__PURE__*/_react.default.createElement(_reactThreeFiber.Canvas, null, /*#__PURE__*/_react.default.createElement("ambientLight", {
    color: new THREE.Color(1, 1, 1),
    intensity: 0.8
  }), /*#__PURE__*/_react.default.createElement("pointLight", {
    power: 80,
    distance: 100,
    position: [-50, -30, 10]
  }), /*#__PURE__*/_react.default.createElement(ObjectFile, null));
}